<template>
  <div class='NaveProd'>
    <select-categ/>
    <div class="c-filter">
      <span :class="{ focus: FilterProdPainel.status }" @click="getFilter(true)">
        Publicado ({{ ProdutoStatus.publicados }})
      </span>
      <span>|</span>
      <span :class="{ focus: !FilterProdPainel.status }" @click="getFilter(false)">
        Arquivado ({{ ProdutoStatus.arquivados }})
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectCateg from './SelectCateg'
export default {
  name: 'NaveProd',
  components: { SelectCateg },
  computed: {
    ...mapGetters(['Produtos', 'FilterProdPainel', 'ProdutoStatus'])
  },
  methods: {
    ...mapActions(['changeFilterProdPainel', 'GetProduct', 'Loading', 'GetProdutoStatus']),
    getFilter (status) {
      this.changeFilterProdPainel({ status: status })
        .then(() => {
          this.Loading(true)
          this.GetProduct({ params: { last: 0, limit: 15, categoria: this.FilterProdPainel.categoria, status: this.FilterProdPainel.status }, init: true })
            .then(res => {
              this.produtos = res
              this.Loading(false)
            })
        })
    }
  },
  created () {
    this.GetProdutoStatus(0)
    this.GetProdutoStatus(1)
  }
}
</script>

<style scoped>
.NaveProd {
  width: 66%;
  display: flex;
}

span {
  padding-left: 1%;
  font-weight: bold;
  cursor: pointer;
  color: #CCCCCC;
}

.focus {
  color: #000000
}

.c-filter {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .NaveProd {
    width: 80%;
  }
}
</style>
